// extracted by mini-css-extract-plugin
export default {"container":"Application_container__KP4yz"};